import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { FormEvent } from "primereact/ts-helpers";
import { ITimeProps } from "../../../utils/cellInterfaces";

const strTimeToDate = (strTime: string) => {
  const split = strTime.split(":");
  if (split.length !== 2) {
    return undefined;
  }

  const timeDate = new Date();
  timeDate.setHours(+split[0]);
  timeDate.setMinutes(+split[1]);

  return timeDate;
};

export default function Time(props: ITimeProps) {
  const [time, setTime] = useState<Date | undefined>(strTimeToDate(props.value));

  const handleChangeEvent = (val: FormEvent<Date, React.SyntheticEvent<Element, Event>>) => {
    const timeVal = val.value as Date | undefined;
    if (timeVal) {
      setTime(timeVal);
      const changedVal = `${String(timeVal?.getHours()).padStart(2, "0")}:${String(timeVal?.getMinutes()).padStart(2, "0")}`;
      props.changeHandler(changedVal);
    } else {
      setTime(undefined);
      props.changeHandler("-");
    }
  };

  if (props.isInEditMode) {
    return (
      <div>
        <Calendar
          value={time}
          onChange={handleChangeEvent}
          placeholder="Time not set"
          timeOnly
          stepMinute={1}
        />
      </div>
    );
  }
  return (
    <div
      className="p-inputtext"
      style={{
        padding: "auto",
        border: "none",
        backgroundColor: "transparent",
        color: "inherit",
        whiteSpace: "nowrap",
      }}
    >
      {props.value ? props.value : "-"}
    </div>
  );
}
